import { makeStyles, Typography } from "@material-ui/core"
import React from "react"
import { useRetrospectiva } from "../context/RetrospectivaContext"
import { ContainerInsta } from "./ContainerInsta"
import { lavaFoldsSvg } from "./Svg"

const useStyles = makeStyles(() => ({
    container: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    titulo: {
        fontSize: 25,
        color: "white",
        fontWeight: 700,
        textShadow: "0px 6px 18px rgba(0,0,0,.5)",
        marginBottom: 6,
        textAlign: "center",
    },
    list: {
        display: "grid",
        gridTemplateColumns: "1fr",
        rowGap: 16,
    },
    item: {
        width: "100%",
        display: "grid",
        gridTemplateColumns: "auto 1fr",
        alignItems: "center",
        columnGap: 12,
        padding: "10px 12px",
        borderRadius: 12,
        backgroundColor: "rgba(0,0,0,0.3)",
    },
    rank: {
        fontSize: "45px",
        color: "white",
        fontWeight: 700,
        textShadow: "0px 6px 18px rgba(0,0,0,0.5)",
        display: "inline-block",
        padding: "0 6px",
    },
    nome: {
        fontSize: 18,
        color: "white",
        fontWeight: 700,
        textShadow: "0px 6px 18px rgba(0,0,0,0.5)",
        marginBottom: 6,
        lineHeight: 1.15,
        width: "214px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    sub: { fontSize: 12, color: "white", marginTop: 4 },
}))

export function TopClientes() {
    const classes = useStyles()
    const dadosRestrospectiva = useRetrospectiva()
    const topClientes = dadosRestrospectiva?.topClientes

    const gradEmbers = "linear-gradient(180deg, #1b0a06 0%, #5a1e10 55%, #751422 100%)"

    return (
        <ContainerInsta img={lavaFoldsSvg} gradiente={gradEmbers}>
            <div className={classes.container}>
                <Typography className={classes.titulo}>Top 5 Clientes</Typography>

                <div className={classes.list}>
                    {topClientes?.map((c, idx) => (
                        <div className={classes.item} key={idx}>
                            <div className={classes.rank}>{idx + 1}º</div>
                            <div>
                                <div className={classes.nome}>{c.nome}</div>
                                {c?.qtdPedidos && (
                                    <div className={classes.sub}>
                                        Quantidade de pedidos: {c.qtdPedidos}
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </ContainerInsta>
    )
}
